module.exports = __webpack_public_path__ + "b5c72d28bb7979d65f0a9d9c924eb006.jpeg";


//////////////////
// WEBPACK FOOTER
// ./public/bg32.jpeg
// module id = 42
// module chunks = 0